import { useCallback, useState } from 'react';

import { useAddToast } from '../../../../../contexts/ToastContext';
import { getErrorMessage } from '../../../../../ReactQuery/errors';
import { get } from '../../../../../redux/api';
import { nuc } from '../../../../../utils';

/**
 * Simple hook for managing the "reanalyze dependency"
 * request and button state.
 * @deprecated Use @app/hooks/api/revisions/useRebuildRevision.ts instead.
 */
const useRebuildRevision = (revisionLocator: string) => {
  const [hasRebuilt, setHasRebuilt] = useState(false);
  const addToast = useAddToast();

  const onRebuild = useCallback(async () => {
    try {
      if (revisionLocator) {
        await get(`/api/revisions/${nuc(revisionLocator)}/rebuild`);
        setHasRebuilt(true);
      }
    } catch (error) {
      addToast({ type: 'error', content: getErrorMessage(error, 'Failed to reanalyze dependency. Try again.') });
    }
  }, [addToast, revisionLocator]);

  return {
    hasRebuilt,
    onRebuild,
  };
};

export default useRebuildRevision;
